import "@/App.css";
import ProposalWarm from "@/proposals/ProposalWarm";

function App() {
  return (
    <div className="App">
      <ProposalWarm />
    </div>
  );
}

export default App;
